<template>
  <v-container>
    <v-row>
      <v-col>
       <v-card class="mt-2">
          <v-toolbar color="primary" dark>
            <v-tabs v-model="tab">
              <v-tab>Konfigurasi Ombrometer</v-tab>
              <v-tab>Konfigurasi TMA</v-tab>
            </v-tabs>
          </v-toolbar>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <CalibrateOmbro/>
              </v-tab-item>
              <v-tab-item>
                <CalibrateTMA/>
              </v-tab-item>
            </v-tabs-items>
       </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CalibrateOmbro from './Ombrometer/CalibrateOmbro.vue'
import CalibrateTMA from './TMA/CalibrateTMA.vue'

export default {
  components: { CalibrateTMA, CalibrateOmbro },
  data: () => ({
    tab:null,
  }),
}
</script>
